import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'dato';
            break;
        case 'dato':
            nextPage = 'adresse';
            break;
        case 'adresse':
            nextPage = 'beskriv-skaden';
            break;
        case 'beskriv-skaden':
            nextPage = 'beskriv-skaderne';
            break;
        case 'beskriv-skaderne':
            nextPage = 'koeretoej-nummerplade';
            break;
        case 'koeretoej-nummerplade':
            nextPage = 'situation';
            break;
        case 'situation':
            nextPage = 'foerer';
            break;
        case 'foerer':
            nextPage = 'oplysninger-om-modpart';

            const isDriverSomeoneElse =
                getValueOrDefault(formConfig, formValues, 'whoDroveYourVehicle').value === 'someoneElse';
            if (isDriverSomeoneElse) {
                nextPage = 'foerer-oplysninger';
            }

            break;
        case 'foerer-oplysninger':
            nextPage = 'oplysninger-om-modpart';
            break;
        case 'oplysninger-om-modpart':
            nextPage = 'ansvar';

            const isCounterpartSelected =
                getValueOrDefault(formConfig, formValues, 'doYouHaveInformationAboutOthersInvolved').value === 'yes';
            if (isCounterpartSelected) {
                nextPage = 'om-modparten-1';
            }

            break;

        case 'om-modparten-1':
            nextPage = isAddAnotherPersonChecked(
                'doYouHaveInformationAboutOthersInvolvedAddMorePersons-addPerson2',
                formConfig,
                formValues
            )
                ? 'om-modparten-2'
                : 'ansvar';
            break;
        case 'om-modparten-2':
            nextPage = isAddAnotherPersonChecked(
                'doYouHaveInformationAboutOthersInvolvedAddMorePersons-addPerson3',
                formConfig,
                formValues
            )
                ? 'om-modparten-3'
                : 'ansvar';
            break;
        case 'om-modparten-3':
            nextPage = 'ansvar';
            break;

        case 'ansvar':
            nextPage = 'dokumentation';
            break;

        case 'dokumentation':
            nextPage = 'politi-og-samtykke';
            break;
        case 'politi-og-samtykke':
            nextPage = 'andet-selskab';

            if (getValueOrDefault(formConfig, formValues, 'policeContacted').value === 'Y') {
                nextPage = 'samtykke';
            }

            break;
        case 'samtykke':
            nextPage = 'andet-selskab';
            break;

        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'om-dig';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};

/**
 * Determines if a given 'add another person' checkbox element is selected or not.
 * @param elementId Id of the 'add another person' checkbox element
 * @param formConfig
 * @param formValues
 * @returns True if the 'add another person' checkbox is selected, else false.
 */
const isAddAnotherPersonChecked = (elementId: string, formConfig: FormConfig, formValues: FormValues): boolean => {
    const addAnotherPersonCheckbox = getValueOrDefault(formConfig, formValues, elementId);
    return addAnotherPersonCheckbox && addAnotherPersonCheckbox.length > 0
        ? addAnotherPersonCheckbox[0].value === 'yes'
        : false;
};
